import { type MouseEvent, forwardRef } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const MoonIcon = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      d="M2.71082 9.97018C2.54804 9.91229 2.38014 10.062 2.44194 10.2233C2.79599 11.1476 3.37342 11.9727 4.12547 12.6232C4.99039 13.3714 6.05049 13.8577 7.18174 14.0254C8.31299 14.1931 9.46859 14.0351 10.5133 13.5699C11.5581 13.1048 12.4487 12.3517 13.0811 11.3989C13.7134 10.446 14.0614 9.33276 14.0841 8.18938C14.1069 7.046 13.8035 5.91979 13.2096 4.94252C12.6156 3.96526 11.7556 3.17735 10.7302 2.67101C9.83864 2.23074 8.85405 2.01918 7.86481 2.052C7.69214 2.05773 7.61945 2.27059 7.73603 2.39809C8.38713 3.11022 8.80496 4.0093 8.92622 4.97387C9.06612 6.08674 8.80193 7.21286 8.18172 8.14741C7.56151 9.08196 6.62646 9.76286 5.54665 10.0663C4.61073 10.3293 3.61994 10.2935 2.71082 9.97018Z"
    />
  </svg>
));
